/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MarkupTypeResponse
 */
export interface MarkupTypeResponse {
    /**
     * 
     * @type {string}
     * @memberof MarkupTypeResponse
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MarkupTypeResponse
     */
    name?: string | null;
}

export function MarkupTypeResponseFromJSON(json: any): MarkupTypeResponse {
    return MarkupTypeResponseFromJSONTyped(json, false);
}

export function MarkupTypeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MarkupTypeResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': !exists(json, 'code') ? undefined : json['code'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function MarkupTypeResponseToJSON(value?: MarkupTypeResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'name': value.name,
    };
}


